import React from 'react'

import { useStyles } from './textarea.style'

function TextareaComponent ({ size, label, rows, className = '', ...props }, ref) {
  const classes = useStyles()
  return (
    <label>
      <div className={(size === 'medium') ? 'form-element-label-medium' : 'form-element-label'}>{label}</div>
      <div className="form-element-wrapper">
        <textarea data-qa={`textarea-component-${label}`} ref={ref} className={`form-element ${(size === 'medium') ? classes.textareaMedium : classes.textarea} ${className}`} rows={rows || 8} {...props}></textarea>
        <div className="form-element-border"></div>
      </div>
    </label>
  )
}

export const Textarea = React.forwardRef(TextareaComponent)
